import Image from 'next/image';

import cn from '@/lib/clsxm';

export default function Spinner({ className }: { className?: string }) {
  const imageSrc = '/images/spinner/badge.svg';

  return (
    <div
      className={cn(
        'inset-0 z-1000 flex h-[200px] w-full items-center justify-center bg-transparent/55',
        className,
      )}
    >
      <div className='relative inline-block h-[80px] w-[80px] rounded-full bg-white shadow-2xl'>
        <div
          className='absolute -inset-3 rounded-full'
          style={{
            background: 'radial-gradient(rgba(255, 255, 255, 0.01), rgba(255, 255, 255, 0.5))',
            padding: '12px',
          }}
        ></div>
        <div className='bg-spinner animate-spin-around absolute -inset-6 rounded-full' />
        <Image
          src={imageSrc}
          alt='spinner'
          width={40}
          height={40}
          unoptimized
          className='absolute inset-0 m-auto h-[40px] w-[40px]'
        />
      </div>
    </div>
  );
}
